/**
 * Deeply parse a value and apply a parser to each value
 */
export type DeepParseValue = string | number | boolean | null | undefined | DeepParseValue[] | Record<string, unknown>;

export const deepParse = (
  value: DeepParseValue,
  parser: (val: DeepParseValue, keyOrIndex?: string | number) => DeepParseValue,
  keyOrIndex?: string | number
): DeepParseValue => {
  if (Array.isArray(value)) {
    return value.map((item, idx) => deepParse(item, parser, idx));
  } else if (value !== null && typeof value === 'object') {
    const result: Record<string, DeepParseValue> = {};
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        result[key] = deepParse(value[key] as DeepParseValue, parser, key);
      }
    }
    return result;
  }
  return keyOrIndex !== undefined ? parser(value, keyOrIndex) : value;
};
